import React, {useEffect} from 'react'
import {Helmet} from "react-helmet";
import ImgOne from '../images/number-one.png'
import ImgTruck from '../images/step-three-truck.png'
import Img3Times from '../images/bb-3times.svg'
import ImgPromise from '../images/step-three-promise.jpg'

const StepThree = ({packData}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <div className="step step-three step-wrapper">
        <Helmet>
            <meta charSet="utf-8" />
            <title>Packing Location || Busy Bee Honey</title>
        </Helmet>
            <div className="contain">

                <section>
                    <h1>THIS HONEY WAS CAREFULLY PACKAGED IN:</h1>
                    <p><strong>{packData.packingLocation}</strong></p>
                    <p>When the packing facilities receive the raw honey from our trusted beekeeper partners, samples from each lot are drawn by quality personnel. Busy Bee Raw Honey isn't packaged until all testing is complete and the honey passes all of Barkman Honey's stringent quality standards.</p>
                </section>
            </div>

            <section className="cream-bkg truck-section">
                <div className="white-stripe"></div>
                <div className="contain">
                    <div className="img-wrapper">
                        <img src={ImgTruck} alt="" />
                    </div>
                    <p><em>
                    Barkman Honey works to limit the food miles between where honey is made, harvested and packed, in keeping with the company’s focus on putting sustainable honey on your family's table.</em></p>
                </div>
            </section>

            <section className="honey-promise-section">
                <div className="contain">
                    <div className="honey-promise-title">
                           
                            <img src={Img3Times} alt="Tested three times" />
                            
                       
                            <h2>Real honest<br />honey promise</h2>
                       
                    </div>
                    <div className="img-wrapper">
                        <img src={ImgPromise} alt="Honey sample cups" />
                    </div>
                    <div className="promise-list">
                        <ul>
                            <li>Busy Bee Raw Honey is tested for safety, quality — and <span className="underline">three times</span> for purity.</li>
                            <li>All products are U.S. Grade A and meet Safe Quality Foods (SQF) standards and True Source Certified<sup>®</sup> supply chain transparency.</li>
                            <li>Each lot of Busy Bee Raw Honey undergoes pollen analysis to help identify the floral sources used to make the honey.</li>
                        </ul>
                    </div>
                </div>
            </section>
           
            <section className="cream-bkg number-ones step-three-number-ones">
                <div className="contain">
                    <div className="step-icon">
                        <img src={ImgOne} alt="" />
                    </div>
                    <p><strong>Barkman Honey was the first honey packer to:</strong></p>
                    <p><em>Adopt Safe Quality Foods (SQF) standards in the industry</em></p>
                    <p><em>Invest in our own state-of-the-art lab to rigorously test for quality and safety</em></p>
                    <p><em>Certify  a transparent supply chain through the True Source Certified<sup>®</sup> Honey program</em></p>
                </div>
            </section>
          
        </div>
    )
}

export default StepThree
